import React from 'react';
import { Box, Typography } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { AdsClickOutlined } from '@mui/icons-material';

const iconWrap = (bg) => ({
  width: 32,
  height: 32,
  borderRadius: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 1,
  backgroundColor: bg,
});

const card = (bg) => ({
  width: 200,
  p: 2,
  borderRadius: 2,
  backgroundColor: bg,
  textAlign: 'left',
});

const InfoBoxes = () => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center', mt: 4 }}>
    {/* Brand Names */}
    <Box sx={card('#ECFDF3')}>
      <Box sx={iconWrap('#D1FAE5')}>
        <CategoryIcon sx={{ fontSize: 18, color: '#059669' }} />
      </Box>
      <Typography variant="h6" fontWeight={600}>
        Brand Names
      </Typography>
      <Typography variant="body2" style={{color:'#333'}}>
        Search commercial brands like “Tylenol” or “Advil”
      </Typography>
    </Box>

    {/* Generic Names */}
    <Box sx={card('#F0F7FF')}>
      <Box sx={iconWrap('#DBEAFE')}>
        <ShowChartIcon sx={{ fontSize: 18, color: '#2563EB' }} />
      </Box>
      <Typography variant="h6" fontWeight={600}>
        Generic Names
      </Typography>
      <Typography variant="body2" style={{color:'#333'}}>
        Find by active ingredients like “Acetaminophen”
      </Typography>
    </Box>

    {/* Alternatives */}
    <Box sx={card('#FFF7F9')}>
      <Box sx={iconWrap('#ffeaee')}>
        <AdsClickOutlined sx={{ fontSize: 18, color: 'error.light' }} />
      </Box>
      <Typography variant="h6" fontWeight={600}>
        Side Effects
      </Typography>
      <Typography variant="body2" style={{color:'#333'}}>
        View common side effects with one click.
      </Typography>
    </Box>
  </Box>
);

export default InfoBoxes;
